/* Arcana — scroll reveal + image fade-in
   Adds .is-visible to elements as they enter the viewport.
   Adds .is-loaded to images once they finish loading (for fade-in).
*/
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;

  const REVEAL_SELECTOR = [
    '.arcana-page-hero__inner',
    '.arcana-page-hero:not(:has(.arcana-page-hero__inner))',
    '.arcana-cat__hero',
    '.arcana-cat__cards > *',
    '.arcana-cat__panel',
    '.arcana-cat__cta',
    '.arcana-shipping__hero',
    '.arcana-shipping__card',
    '.arcana-shipping__rates',
    '.arcana-shipping__row > *',
    '.arcana-intro__hero',
    '.arcana-intro__story-card',
    '.arcana-intro__principles',
    '.arcana-intro__cta',
    '.arcana-faq__hero',
    '.arcana-faq__list',
    '.arcana-faq__cta',
    '.arcana-terms__hero',
    '.arcana-terms__body',
    '.arcana-page-body__inner',
    '.arcana-page-cta__inner',
    '.arcana-highlights__head',
    '.arcana-highlights__card',
    '.arcana-directory__group',
    '.arcana-contact-details',
    '.contact .title',
  ].join(', ');

  const markImagesLoaded = () => {
    const imgs = document.querySelectorAll('.arcana-directory__card-image img, .arcana-cat__card-media img');
    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
        img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
      }
    });
  };

  const targets = document.querySelectorAll(REVEAL_SELECTOR);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    targets.forEach((el) => el.classList.add('is-visible'));
    markImagesLoaded();
    return;
  }

  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    });
  }, {
    threshold: isMobile ? 0.05 : 0.08,
    rootMargin: isMobile ? '0px 0px -4% 0px' : '0px 0px -40px 0px',
  });

  targets.forEach((el) => {
    el.classList.add('arcana-reveal');
    io.observe(el);
  });

  markImagesLoaded();

  // Disconnect the observer on unload (also covers bfcache).
  window.addEventListener('pagehide', function teardown() {
    io.disconnect();
    window.removeEventListener('pagehide', teardown);
  });
})();
